<div class="bloc">
  <div class="bloc-header">
    <div class="bloc-title">Fonctionnalités</div>
  </div>
  <div class="checkbox-grid">
    <label class="checkbox-item">
      <input type="checkbox" [(ngModel)]="form.onlineAgenda" (ngModelChange)="onFieldChange()"/>
      <span class="checkmark"></span>
      <span>Agenda en ligne</span>
    </label>
    <label class="checkbox-item">
      <input type="checkbox" [(ngModel)]="form.patientApp" (ngModelChange)="onFieldChange()"/>
      <span class="checkmark"></span>
      <span>Application patient</span>
    </label>
    <label class="checkbox-item">
      <input type="checkbox" [(ngModel)]="form.ivgModule" (ngModelChange)="onFieldChange()"/>
      <span class="checkmark"></span>
      <span>Module IVG</span>
    </label>
    <label class="checkbox-item">
      <input type="checkbox" [(ngModel)]="form.kineModule" (ngModelChange)="onFieldChange()"/>
      <span class="checkmark"></span>
      <span>Module kiné</span>
    </label>
    <label class="checkbox-item">
      <input type="checkbox" [(ngModel)]="form.bubblelink" (ngModelChange)="onFieldChange()"/>
      <span class="checkmark"></span>
      <span>Bubblelink</span>
    </label>
  </div>
</div>
